angular.module("avlib").directive("avTextFilter", function(){
	return {
		template: require("!html-loader!./TextFilterTemplate.html"),
		restrict: "E",
		scope: {
			filter: '=',
            onChange: '&',
		},
		
		controller: ["$scope", function($scope){
		}],
	};
});